"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildShareButtonComponent = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _shapes = require("./shapes");

var _color_helper = require("../../helpers/color_helper");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var buildShareButtonComponent = function buildShareButtonComponent(_ref) {
  var action = _ref.action,
      ariaLabel = _ref.ariaLabel,
      buttonLabel = _ref.buttonLabel,
      color = _ref.color,
      icon = _ref.icon;
  var Icon = icon;
  var hoverColor = (0, _color_helper.changeBrightness)(color, -20);
  var activeColor = (0, _color_helper.changeBrightness)(color, -40);

  var ShareButton = function ShareButton(props) {
    var Shape = _shapes.shapes[props.shape];

    var handleClick = function handleClick(event) {
      event.preventDefault();
      props.beforeOnClick && props.beforeOnClick(event);
      action(props);
    };

    return /*#__PURE__*/_react["default"].createElement(Shape, {
      activeColor: activeColor,
      "aria-label": ariaLabel,
      boxShadow: props.boxShadow,
      className: props.className,
      color: props.color || color,
      href: "#",
      hoverColor: props.color || hoverColor,
      onClick: handleClick,
      role: "button",
      title: props.title || '',
      label: buttonLabel || ariaLabel
    }, props.shape === 'full' ? /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(Icon, null)) : /*#__PURE__*/_react["default"].createElement(Icon, null), (props.shape === 'minimal' || props.shape === 'full') && /*#__PURE__*/_react["default"].createElement("span", null, props.content));
  };

  ShareButton.propTypes = Object.assign({}, shareButtonPropTypes);
  return ShareButton;
};

exports.buildShareButtonComponent = buildShareButtonComponent;
var shareButtonPropTypes = {
  className: _propTypes["default"].string,
  beforeOnClick: _propTypes["default"].func,
  boxShadow: _propTypes["default"].bool,
  withLabel: _propTypes["default"].bool,
  content: function content(props, key, klass) {
    // ignore this prop for button shapes that don't use it
    if (props.shape === 'square' || props.shape === 'round') return; // require it for other shapes

    if (typeof props[key] !== 'string' || props[key] === '') return new Error("prop ".concat(key, " must be non-empty string for ").concat(klass, " of shape ").concat(props.shape));
  },
  shape: _propTypes["default"].oneOf(['full', 'minimal', 'round', 'square', 'roundWithLabel']).isRequired,
  shareUrl: _propTypes["default"].string.isRequired,
  teaser: _propTypes["default"].string,
  title: _propTypes["default"].string,
  utmParams: _propTypes["default"].object,
  color: _propTypes["default"].string
};